export const carmaAsciiInConsole = () => {
  const carmaAscii = `
                                                                                           /(       
                                                                                  (((((((((((       
                                                                    ((((((      ((((     \(((       
                                                        /((((((((((((((((((    (((/       (((       
                                              ((((   (((((/  (((((     ((((   ((((       /(((       
      (((((((((((                ((    (((((((((    ((((/     ((((     ((((    ((((     /(((((((((((
   (((((/     (((       (((((((((((      ((((        ((((     ((((     (((((((((((((((((/           
  ((((                ((((     \(((      ((((        ((((     ((((      (((((((/                    
 ((((                (((/       (((      ((((        ((((     ((((                                  
((((                ((((       /(((      (((((((((((((((                                            
 (((,             (((((((     /(((((((((((((/                                                       
 (((((         /((((  ((((((((/                                                                     
   (((((((((((((((                                                                                  
       (((((                                                                                        

Buy or sell a pre-owned car.
The way everyone deserves.
`;

  console.log(`%c${carmaAscii}`, `color: #ff385c; white-space: nowrap; font-family: monospace;`);
};
